/** @module api/ems_energy_manager */

import { apiCall } from '@/api/index'
import { statusApiV1EnergyManagementSystemEmsActuatorGroupPath } from '@/../lib/routes'

/**
 * GET an Actuator Group Status by id
 *
 * @function
 *
 * @param {object} params
 * @param {integer} params.emsId has to be the EMS-ID
 * @param {string} params.id has to be the Actuator Group's ID
 * @param {string} params.storeType has to be the store type, e.g.`'CHARGE_POINT_MANAGER'`
 *
 * @return {Promise}
 */
export function getActuatorGroupStatus({ ctxt = 'customer', emsId, id, storeType }) {
  return apiCall({
    path: statusApiV1EnergyManagementSystemEmsActuatorGroupPath(ctxt, emsId, id, storeType)
  })
}
